import { ImportStatsTable } from '../views/import-stats-table';
import { ImportStats } from '../dtos/import-stats';

export const IMPORT_STATS_TABLE = (
	importStatsList: Array<ImportStats> = [],
	usersList: Array<any> = []
): Array<ImportStatsTable> => {
	let results: Array<ImportStatsTable> = [];
	try {
		if (importStatsList.length > 0) {
			importStatsList.map((importStat: ImportStats) => {
				let row = {} as ImportStatsTable;
				row.c4UserId = importStat.c4UserId;
				if (importStat.userName) {
					row.userName = importStat.userName;
				} else if (row.c4UserId) {
					const user = usersList?.find((user) => user.userId == row.c4UserId);
					if (user) {
						row.userName = user?.name;
					}
				}
				row.created = importStat.created;
				row.filename = importStat.filename;
				row.id = importStat.id;
				row.invalidRows = importStat.invalidRows;
				row.jobStatus = importStat.jobStatus;
				row.relativeUrl = importStat.relativeUrl;
				row.rowsFailed = importStat.rowsFailed;
				row.rowsInserted = importStat.rowsInserted;
				row.rowsParsed = importStat.rowsParsed;
				row.totalRows = importStat.totalRows;
				row.type = importStat.type;
				row.updated = importStat.updated;
				row.c4AccountBusinessName = importStat.c4AccountBusinessName;
				row.c4AccountId = importStat.c4AccountId;
				// CN-8869: carry the Bulk Rating job summary (+ failure fields) through this
				// mapper — this fixed-shape copy previously dropped them, so the list-view
				// Avg Confidence / Coverage columns always rendered "—" even when the endpoint
				// returned resultSummary. Applies to both the list fetch and websocket add/update.
				row.resultSummary = importStat.resultSummary;
				row.failureReason = importStat.failureReason;
				row.retryable = importStat.retryable;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('IMPORT_STATS_TABLE error: ', error);
	}
	return results;
};
